module.exports = __webpack_public_path__ + "img/newEmail.23eb70e3.svg";